module.exports = require("buffer");


//////////////////
// WEBPACK FOOTER
// external "buffer"
// module id = 519
// module chunks = 0